module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e19-6e48f849cb270ae22198e580c339d655.jpg";